import ShpAdministracionUsuarios from '@/components/Administracion/ShpAdministracionUsuarios'
import ShpMiCuenta from '@/components/Catalogo/ShpMiCuenta'
import ShpInformes from '@/components/Informes/ShpInformes'
import ShpInitStyle from '@/components/ShpInitStyle'
import ShpLogin from '@/components/ShpLogin'
import AccessWithToken from '@/views/AccessWithToken'
import AccesWithExpert from '@/views/AccessWithExpert'
import ShpStates from '@/components/Pelikane/ShpStates'
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// Guarda de autenticación reutilizable
const authGuard = (to, from, next) => {
  if (localStorage.getItem('urlInfo')) {
    next();
  } else {
    next('/');
  }
};

const router = new Router({
  routes: [{
    path: '/',
    name: 'ShpLogin',
    component: ShpLogin
  },
  {
    path: '/style',
    name: 'ShpInitStyle',
    component: ShpInitStyle,
    beforeEnter: authGuard
  },
  {
    path: '/informes',
    name: 'ShpInformes',
    component: ShpInformes,
    beforeEnter: authGuard
  }, {
    path: '/administracion/usuarios',
    name: 'ShpAdministracionUsuarios',
    component: ShpAdministracionUsuarios,
    beforeEnter: authGuard
  },
  {
    path: '/login/:pToken',
    name: 'AccessWithToken',
    component: AccessWithToken,
    props: true
  },
  {
    path: '/login/:pToken/:pTienda',
    name: 'AccessWithToken',
    component: AccessWithToken,
    props: true
  },
  {
    path: '/loginExpert/:pToken',
    name: 'AccessWithExpert',
    component: AccesWithExpert,
    props: true
  },
  {
    path: '/miCuenta',
    name: 'ShpMiCuenta',
    component: ShpMiCuenta,
    beforeEnter: authGuard
  }, {
    path: '/tracking',
    name: 'ShpStates',
    component: ShpStates,
    beforeEnter: authGuard
  }

  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js